"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDescriptionConfig = void 0;
var defaultDescriptionConfig = {
    textAlign: 'left',
    padding: {
        desktop: 0,
        tablet: 0,
        mobile: 0
    },
    margin: {
        desktop: '0 0 1em',
        tablet: '0 0 1em',
        mobile: '0 0 1em'
    },
    fontSize: {
        desktop: '18px',
        tablet: '18px',
        mobile: '16px'
    },
    fontStyle: 'normal',
    letterSpacing: 'normal',
    textDecoration: 'none'
};
exports.defaultDescriptionConfig = defaultDescriptionConfig;
//# sourceMappingURL=Description.js.map